export type LoginFlow = 'PASSWORD' | 'PASSWORD_OTP' | 'SSO';

export type FlowStatus = 'AUTHENTICATED' | 'MFA_VERIFICATION_REQUIRED' | 'RECOVERY_REQUIRED';

export interface SsoDescriptor {
  provider: string | null;
  authorization_url: string | null;
  state: string | null;
  redirect_uri: string | null;
}

export interface MfaDescriptor {
  required: boolean;
  factor_type: string | null;
  remember_device_allowed: boolean;
}

export interface LoginFlowResponse {
  flow: LoginFlow;
  sso: SsoDescriptor;
  mfa: MfaDescriptor;
}

export interface MfaChallenge {
  challengeId: string;
  factorType: string | null;
  expiresInSeconds: number;
  remainingAttempts: number;
  remainingResends: number;
  resendAvailableInSeconds: number;
}

export interface RecoveryDescriptor {
  recoveryToken: string;
  recoveryType: string | null;
}

export interface SessionTokens {
  token: string;
  refreshToken: string;
  token_id?: string | null;
  profile_completeness_show_modal?: boolean;
  profile_completeness?: { percentage?: number } | null;
  sso_provider?: string | null;
  sso_connection?: string | null;
}

export interface PasswordStepResult {
  status: FlowStatus;
  tokens: SessionTokens | null;
  challenge: MfaChallenge | null;
  recovery: RecoveryDescriptor | null;
}

export interface MfaVerifyResult {
  tokens: SessionTokens | null;
  trustedDeviceToken: string | null;
  trustedDeviceExpiresAt: string | null;
}

export interface McpHandoffResponse {
  handoff_code: string;
  expires_in: number;
}

export const DEFAULT_EXPIRES_IN_SECONDS = 180;
export const DEFAULT_RESEND_AVAILABLE_IN_SECONDS = 60;
